import { currencies, defaultCurrency } from 'common/constants';
import { Currency } from 'common/types';
import { useAppSelector } from 'core/hooks/hooks';
import { useCurrency } from 'core/hooks/useCurrency';
import { budgetMonthSelector } from 'core/store/selectors/monthBudget.selector';
import { periodSelector } from 'core/store/selectors/period.selector';

export interface MonthCurrencyLabelProps {
  currency: Currency;
}

const MonthCurrencyLabel = () => {
  const { currency } = useCurrency();
  const currencyData = currencies[currency || defaultCurrency];
  return (
    <span
      style={{
        background: '#aaa',
        color: 'white',
        height: '24px',
        width: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        fontSize: '0.875rem',
        fontWeight: '500'
      }}
    >
      {currencyData.symbol}
    </span>
  );
};

export default MonthCurrencyLabel;
